module.exports = __webpack_public_path__ + "img/BNR_OHG.18785b2b.jpg";